<template>
  <v-dialog persistent v-model="show" max-width="700px">
    <v-card flat>
      <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>

      <h2>{{ $t('login.password.password-changed') }}</h2>
      <v-card-text class="pl-0 pr-0"> {{ $t('login.password.changed-sucess') }}</v-card-text>

      <ActionButton class="mt-4" actionIcon="$sl-password-type" @click="$emit('close')">{{
        $t('login.password.login-with-password')
      }}</ActionButton>
    </v-card>
  </v-dialog>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton'

export default {
  name: 'RestoreSuccessModal',

  props: {
    show: false
  },

  components: {
    ActionButton
  }
}
</script>

